export default function getNextDayAtMidnight(date) {
  // Get the current date
  let currentDate = new Date(date);

  // Set the time to 00:00:00 for the following day
  currentDate.setDate(currentDate.getDate() + 1);
  currentDate.setHours(0, 0, 0, 0);

  return currentDate;
}
